var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.563 4.585a1.396 1.396 0 00-1.907 0 1.243 1.243 0 000 1.818l4.55 4.336 8.92-8.501a1.243 1.243 0 000-1.818 1.396 1.396 0 00-1.907 0L5.207 7.104l-2.644-2.52z"
  })));
}
export default SvgCheck;